<template>
  <svg :style="style" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Frame" clip-path="url(#clip0_3654_57157)">
      <path id="Vector"
        d="M19.5 3H4.5C3.67157 3 3 3.67157 3 4.5V19.5C3 20.3284 3.67157 21 4.5 21H19.5C20.3284 21 21 20.3284 21 19.5V4.5C21 3.67157 20.3284 3 19.5 3Z"
        :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
      <path id="Vector_2" d="M10.5 6.5H6.5V10.5H10.5V6.5Z" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
      <path id="Vector_3" d="M17.5 6.5H13.5V10.5H17.5V6.5Z" :stroke="color" stroke-width="1.5" stroke-linejoin="round" />
      <path id="Vector_4" d="M10.5 13.5H6.5V17.5H10.5V13.5Z" :stroke="color" stroke-width="1.5"
        stroke-linejoin="round" />
      <path id="Vector_5" d="M17.5 13.5H13.5V17.5H17.5V13.5Z" :stroke="color" stroke-width="1.5"
        stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3654_57157">
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'sort-one',
  props: {
    color: {
      type: String,
      default: 'red'
    },
    width: {
      type: String,
      default: '24px'
    }
  },
  data() {
    return {
      style: {
        width: this.width,
        'vertical-align': 'middle',
        overflow: 'hidden',
      }
    }
  }
}
</script>